package br.com.htms.inspeccaocampo.shared.ui.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.RadioButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.FotoAnexo
import br.com.htms.inspeccaocampo.data.RespostaSimNao
import br.com.htms.inspeccaocampo.data.SecaoSimNao

@Composable
fun CampoSimNaoCard(
    titulo: String,
    secao: SecaoSimNao,
    erro: String?,
    onResposta: (RespostaSimNao) -> Unit,
    onDescricao: (String) -> Unit,
    onTirarFoto: () -> Unit,
    onAdicionarMaisFoto: () -> Unit,
    onRemoverFoto: (FotoAnexo) -> Unit,
    descricaoLabel: String,
    exigirDescricaoSeSim: Boolean,
    exigirFotoSeSim: Boolean,
    modifier: Modifier = Modifier
) {
    var mostrarLista by remember { mutableStateOf(false) }

    Card(
        modifier = modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
    ) {
        Column(
            modifier = Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Text(titulo, fontWeight = FontWeight.SemiBold)
            RespostaSimNao.entries.forEach { opcao ->
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable(role = Role.RadioButton, onClick = { onResposta(opcao) })
                        .padding(vertical = 4.dp)
                ) {
                    RadioButton(selected = secao.resposta == opcao, onClick = null)
                    Text(opcao.rotulo)
                }
            }
            if (secao.resposta == RespostaSimNao.SIM) {
                if (exigirDescricaoSeSim) {
                    OutlinedTextField(
                        value = secao.descricao,
                        onValueChange = onDescricao,
                        label = { Text(descricaoLabel) },
                        modifier = Modifier.fillMaxWidth(),
                        minLines = 2,
                        colors = FormFieldDefaults.textFieldColors(),
                        isError = erro != null
                    )
                }
                if (exigirFotoSeSim) {
                    CampoFotoRow(
                        label = "Tirar foto",
                        obrigatorio = true,
                        quantidadeFotos = secao.fotos.size,
                        onTirarFoto = onTirarFoto,
                        onAdicionarMais = onAdicionarMaisFoto,
                        onAbrirLista = { mostrarLista = true }
                    )
                }
            }
            erro?.let {
                Text(it, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
            }
        }
    }

    if (mostrarLista) {
        val ultimaFoto = secao.fotos.lastOrNull()
        CenteredAppDialog(
            onDismissRequest = { mostrarLista = false },
            title = titulo,
            text = if (secao.fotos.isEmpty()) {
                "Nenhuma foto."
            } else {
                "${secao.fotos.size} foto(s). Remover a última?"
            },
            confirmLabel = if (ultimaFoto != null) "Remover última" else null,
            onConfirm = if (ultimaFoto != null) {
                {
                    onRemoverFoto(ultimaFoto)
                    if (secao.fotos.size <= 1) mostrarLista = false
                }
            } else {
                null
            },
            dismissLabel = "Fechar"
        )
    }
}
